import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar/navbar.tsx';
import Homepage from './pages/homepage.tsx';
import Servizi from './pages/servizi.tsx';
import Prodotti from './pages/prodotti.tsx';
import Contatti from './pages/contatti.tsx';
import NotFound from './pages/notfound.tsx';
import Footer from './components/footer/footer.tsx';
import { TransitionProvider } from './context/TransitionContext.tsx';

import './styles/global.scss';

function App() {
  return (
    <div className="App" style={{ position: 'relative' }}>
      <Router>
        <TransitionProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/prodotti" element={<Prodotti />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </TransitionProvider>
      </Router>
    </div>
  );
}

export default App;
